var pt_br = {
    values: {
        "Input Port": "Porta de entrada",
        "MQTT identifier": "Identificador MQTT",
        "Event type": "Tipo de evento de saída de dados",
        "Broker address": "Endereço do Broker",
        "Publish topic": "Tópico de 'publish'",
        "Publish Quality of Service (QoS)": "'Publish' Qualidade de Serviço (QoS)",
        "User (optional)": "Usuário (opcional)",
        "Password (optional)": "Senha (opcional)",
        "SSL Configuration": "Configurações para SSL",
        "SSLConfiguration Help": "As configurações a seguir são is OPCIONAIS. Somente serão necessárias se uma conexão SSL for usada para conectar no Broker MQTT",
        "KeyStore Type": "Tipo de KeyStore",
        "KeyStore Path": "Caminho do KeyStore",
        "KeyStore Password": "Senha do KeyStore",
        "Key Alias": "Nome da Chave",
        "Key Password": "Senha da Chave",
        "Trusted Store Path": "Caminho do KeyStore de Certificados Confiáveis",
        "Trusted Store Password": "Senha do KeyStore de Certificados Confiáveis",
        "Enable Hostname Verification": "Habilitar Verificação de Hostname",
        "Server Hostname Verification Info": "Isso verificará se o certificado recebido do servidor contém o mesmo hostname que o servidor.",
        "Unit management": "Gerenciador de unidades",
        "Cancel": "Cancelar",
        "UOM list error. Check details": "Erro na lista de UOM. Verifique os detalhes",
        Topic_Management: "Tópicos para se inscrever",
        Topic_Error: "Erro na lista de tópicos. Verifique os detalhes",
        "Topic": "Tópico",
        "QoS": "Qualidade de Serviço (QoS)",
        Empty_Topic: ({ line }) =>
            `Tópico não pode ser vazio na linha ${line}`,
        Topic_Exists: ({ topic, line }) =>
            `Tópico ${topic} na linha ${line} já existe`,
        Invalid_QoS: ({ topic, line }) =>
            `Tópico ${topic} na linha ${line} possui um QoS inválido: QoS deve ser 0, 1 ou 2.`,
        Empty_EventType: ({ topic, line }) =>
            `Tópico ${topic} na linha ${line} possui um Tipo de Evento inválido: Tipo de evento não pode ser vazio.`,
        Wrong_Schema: ({ valueType }) => 
            `Tipo de esquema não encontrado. QoS como número era esperado, mas ${valueType} foi encontrado`,
        Unable_Parse: ({ valueType }) => 
            `Incapaz de converter JSON. Um objeto JSON era esperado em topicsToQoS, mas ${valueType} foi encontrado`,
        "Messages are inserted into LIVE without any format changes.": "As mensagens serão inseridas no LIVE sem qualquer alterações de formato.",
        "Received messages are converted to a format compatible with LIVE channels.": "As mensagens recebidas serão convertidas para um formato compatível com os canais do LIVE.",
    }
};

module.exports = pt_br;
